/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdArrowDropDown,
  MdErrorOutline,
  MdArrowDropUp,
} from 'react-icons/md';

import { AiOutlineDownload } from 'react-icons/ai';

import { CSVLink, CSVDownload } from 'react-csv';
import { IoMdArrowBack } from 'react-icons/io';

import { Pagination, Modal, Row, Col } from 'antd';

import { ClipLoader } from 'react-spinners';

import Breadcumbs from '~/components/Breadcumbs';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import {
  PageTitle,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxPagination,
  BoxButtonDownload,
} from './style';
import { catchErros } from '../LinhasDeCuidado/messages';

import { IdentificadordoPaciente } from '../LinhasDeCuidadoGrid/indentificadorPaciente';
import ButtonBack from '~/components/ButtonBack';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';

const LinhasDeCuidadoDadosFaltantes = props => {
  const { indicador } = props.match.params;

  const [data, setData] = useState([]);

  const [totalCount, setTotalCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const { token, cnes } = store.getState().auth;

  const [pageCurrent, setPageCurrent] = useState(1);

  const [indicadorLinhaDeCuidado, SetIndicadorLinhaDeCuidado] = useState('');

  const [linhaDeCuidadoValue, setLinhaDeCuidadoValue] = useState(null);

  const [periodoSelecionado, setPeriodoSelecionado] = useState('');

  const [titlePage, setTitlePage] = useState('');

  const [dataCsvDownload, setDataCsvDownload] = useState(null);

  const [modalCsvDownload, setModalCsvDownload] = useState(false);

  const [noResults, setNoResults] = useState(false);

  const [lc, setLc] = useState('');

  const limit = 5;

  const [directionAsc, setDirectionAsc] = useState(true);

  const [orderBy, setOrderBy] = useState('');

  const obterErros = async props => {
    const order = props?.orderBy || '';
    const offset = props?.offset || 0;

    const dir = props?.dir;
    const page = props?.currentPage;

    setOrderBy(order);

    setLoading(true);
    try {
      const response = await api.get(
        `indicadores-linhas-de-cuidado/${indicador}/dados-faltantes?limit=${limit}&offset=${offset}&periodo=${periodoSelecionado}${order &&
          `&orderBy=${order}&direction=${dir ? 'asc' : 'desc'}`}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      setData(response?.data);
      setTotalCount(response.headers['total-count']);

      if (response.data.length < 1) {
        setNoResults(true);
      }

      if (!page) {
        setPageCurrent(1);
      }

      setLoading(false);
    } catch (error) {
      catchErros(error);
    }
  };

  const paginationChange = async page => {
    setPageCurrent(page);

    const limitOffset = page - 1;
    const offset = page <= 1 ? 0 : limitOffset * limit;

    obterErros({
      orderBy: orderBy,
      offset: offset,
      currentPage: page,
    });
  };

  useEffect(() => {
    if (linhaDeCuidadoValue) {
      obterErros();
    }
  }, [linhaDeCuidadoValue]);

  useEffect(() => {
    const nomeIndicador =
      (indicador === 'acidente_vascular_cerebral' && 'AVC') ||
      (indicador === 'artropatia_de_quadril' && 'Quadril') ||
      (indicador === 'cancer_de_mama' && 'Câncer de Mama') ||
      (indicador === 'cancer_de_prostata' && 'Câncer de Próstata') ||
      (indicador === 'indicadores_painel_geral' && 'Gerais') ||
      (indicador === 'sepse_e_choque_septico' && 'Sepse') ||
      (indicador === 'sindrome_coronariana_aguda' && 'SCA');

    const indicadorLC =
      (indicador === 'acidente_vascular_cerebral' && 'AVC') ||
      (indicador === 'artropatia_de_quadril' && 'QUA') ||
      (indicador === 'cancer_de_mama' && 'MAM') ||
      (indicador === 'cancer_de_prostata' && 'PRO') ||
      (indicador === 'sepse_e_choque_septico' && 'SEP') ||
      (indicador === 'sindrome_coronariana_aguda' && 'SCA');

    const titleIndicador =
      (indicador === 'indicadores_painel_geral' &&
        'Indicadores do Painel Geral') ||
      (indicador === 'acidente_vascular_cerebral' &&
        'Acidente Vascular Cerebral - AVC') ||
      (indicador === 'artropatia_de_quadril' && 'Artropatia de Quadril') ||
      (indicador === 'cancer_de_mama' && 'Câncer de Mama') ||
      (indicador === 'cancer_de_prostata' && 'Câncer de Próstata') ||
      (indicador === 'sepse_e_choque_septico' && 'Sepse e Choque Séptico') ||
      (indicador === 'sindrome_coronariana_aguda' &&
        'Síndrome Coronariana Aguda - SCA');

    SetIndicadorLinhaDeCuidado(nomeIndicador);
    setLinhaDeCuidadoValue(indicador);

    setLc(indicadorLC);

    setTitlePage(titleIndicador);
    if (props.location.state) {
      setPeriodoSelecionado(props.location.state.periodo);
    }
  }, []);

  // const paginationChange = async page => {
  //   setLoading(true);
  //   setPageCurrent(page);

  //   const limitOffset = page - 1;
  //   const offset = page <= 1 ? 0 : limitOffset * limit;

  //   await api
  //     .get(
  //       `indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}/dados-faltantes?limit=${limit}&offset=${offset}&periodo=${periodoSelecionado}`,

  //       {
  //         headers: {
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then(response => {
  //       setData(response.data);
  //       setTotalCount(response.headers['total-count']);
  //       setLoading(false);
  //     });
  // };

  const downloadCsv = async () => {
    setModalCsvDownload(true);

    try {
      const response = await api.get(
        `indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}/download-csv?periodo=${periodoSelecionado}&tipo=NOTFOUND`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setDataCsvDownload(response.data);
    } catch (error) {
      catchErros(error);

      setModalCsvDownload(false);
    }
  };

  return (
    <>
      <Modal
        title="Baixe os dados no formato .CSV"
        visible={modalCsvDownload}
        onOk={() => {}}
        onCancel={() => setModalCsvDownload(false)}
        centered
        footer={false}
      >
        {dataCsvDownload ? (
          <BoxButtonDownload>
            <CSVLink
              className="botao-verde"
              filename={`${linhaDeCuidadoValue}-${String(
                periodoSelecionado
              ).replace('/', '-')}.csv`}
              data={dataCsvDownload}
            >
              Download do .CSV
            </CSVLink>
          </BoxButtonDownload>
        ) : (
          <BoxButtonDownload>
            <p>Aguarde, carregando...</p>
          </BoxButtonDownload>
        )}
      </Modal>
      <Breadcumbs
        path={`${linhaDeCuidadoValue}`}
        pathTitle={`Adicionar Indicadores de Linhas de Cuidado / ${titlePage}`}
      />

      <PageTitle>
        <div className="headerInline">
          <ButtonBack />
          <div>
            <span>Dados faltantes</span>
            <p>Competência: {periodoSelecionado}</p>
          </div>
        </div>

        <div className="headerButtons">
          <button type="button" onClick={downloadCsv} disabled={!!noResults}>
            <AiOutlineDownload size={16} color="#FFF" />
            Exportar .csv
          </button>
        </div>
      </PageTitle>

      {!loading && data.length > 0 ? (
        <BoxContent>
          <BoxContentHeader>
            <Row>
              <Col span={12}>
                <ButtonOrderBy
                  isActive={orderBy === 'identificadorDoPaciente'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    obterErros({
                      orderBy: 'identificadorDoPaciente',
                      dir: !directionAsc,
                    });
                  }}
                >
                  <span className="nomeArquivoHeader">
                    Identificador do paciente
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>
              <Col span={12}>
                <span>Variável</span>
              </Col>
            </Row>
          </BoxContentHeader>

          {data.map(({ numeroRegistro, variavel }, id) => {
            const idPaciente =
              IdentificadordoPaciente(
                {
                  linhaDeCuidadoValue: 'dados_faltantes',
                  lc,
                  cnes,
                  numeroRegistro,
                },
                periodoSelecionado
              ) || '';

            return (
              <BoxList key={Number(id)}>
                <Row>
                  <Col span={12}>
                    <div className="n_registro">
                      <span>{idPaciente}</span>
                    </div>
                  </Col>
                  <Col span={12}>
                    <span>{variavel}</span>
                  </Col>
                </Row>
              </BoxList>
            );
          })}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      ) : (
        <BoxContent>
          {noResults && (
            <div className="noResults">
              <MdErrorOutline size="40" color="#666" />
              <br />
              <p style={{ color: '#666' }}>Nenhum resultado.</p>
            </div>
          )}
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};

export default LinhasDeCuidadoDadosFaltantes;
